<template>
    <div class="locale-changer"><span @click="changeLocale('fr')">FR</span> / <span @click="changeLocale('en')">EN</span></div>
</template>

<script>
export default {
    name: "LocaleChanger",
    data() {
        return { langs: ["fr", "en"] };
    },
    methods: {
        changeLocale: function (locale) {
            this.$store.dispatch("app/setFilter", "");

            this.$root.$i18n.locale = locale;

            this.$store.dispatch("app/displayNav", false);
        },
    },
};
</script>

<style scoped lang="scss">
span {
    cursor: pointer;
    transition: all 0.4s;

    &:hover,
    &:focus {
        color: #000;
    }
}
</style>
